import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useLang } from "../i18n/LanguageContext";
import { MessageCircle } from "lucide-react";
import { buildWaLink } from "../lib/api";

export const ContactDialog = ({ open, onOpenChange }) => {
  const { t } = useLang();
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contacts", form);
      toast.success(t.contact.success);
      setForm({ name: "", email: "", phone: "", message: "" });
      onOpenChange(false);
    } catch (err) {
      toast.error(t.contact.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="contact-dialog"
        className="max-w-lg border-[#0C2230]/10 bg-[#FBFAF6] p-0 sm:rounded-3xl"
      >
        <div className="p-7 md:p-9">
          <DialogHeader>
            <DialogTitle className="font-[Fraunces] text-3xl font-medium tracking-tight text-[#0C2230]">
              {t.contact.title}
            </DialogTitle>
            <DialogDescription className="mt-2 text-sm text-[#0C2230]/65">
              {t.contact.sub}
            </DialogDescription>
          </DialogHeader>

          <form onSubmit={onSubmit} className="mt-6 flex flex-col gap-4">
            <Input
              data-testid="contact-input-name"
              required
              value={form.name}
              onChange={set("name")}
              placeholder={t.contact.name}
              className="h-12 rounded-xl border-[#0C2230]/15 bg-white"
            />
            <Input
              data-testid="contact-input-email"
              required
              type="email"
              value={form.email}
              onChange={set("email")}
              placeholder={t.contact.email}
              className="h-12 rounded-xl border-[#0C2230]/15 bg-white"
            />
            <Input
              data-testid="contact-input-phone"
              value={form.phone}
              onChange={set("phone")}
              placeholder={t.contact.phone}
              className="h-12 rounded-xl border-[#0C2230]/15 bg-white"
            />
            <Textarea
              data-testid="contact-input-message"
              required
              rows={4}
              value={form.message}
              onChange={set("message")}
              placeholder={t.contact.message}
              className="rounded-xl border-[#0C2230]/15 bg-white"
            />

            <div className="mt-2 flex flex-col gap-3 sm:flex-row">
              <button
                type="submit"
                data-testid="contact-submit"
                disabled={loading}
                className="inline-flex flex-1 items-center justify-center gap-2 rounded-full bg-[#0C2230] px-5 py-3 text-sm font-semibold text-white transition-all hover:bg-[#0a1c27] disabled:opacity-50"
              >
                {loading ? t.contact.sending : t.contact.submit}
              </button>
              <a
                href={buildWaLink(t.waMessages.consult)}
                target="_blank"
                rel="noreferrer"
                data-testid="contact-whatsapp-alt"
                className="inline-flex flex-1 items-center justify-center gap-2 rounded-full bg-[#0E9A57] px-5 py-3 text-sm font-semibold text-white transition-all hover:bg-[#0c8a4d]"
              >
                <MessageCircle className="h-4 w-4" />
                WhatsApp
              </a>
            </div>
          </form>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ContactDialog;
